export default {
	create (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop_reservation/create', params)
	},
	update (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop_reservation/update', params)
	},
	delete (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop_reservation/delete', params)
	},
	all (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop_reservation/all', params)
	},
	one (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop_reservation/one', params)
	},
	count (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop_reservation/count', params)
	},
	reservation_type_count (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop_reservation/reservation_type_count', params)
	},
	checkRefresh (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop_reservation/check_refresh', params)
	},
	searchUnoccupied (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop_reservation/search_unoccupied', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/ShopReservation.js